import styled from "styled-components";
import { HeatMapGrid } from "react-grid-heatmap";

export const GraphicContainer = styled.div`
  margin: 20px auto;
  padding: 20px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  transition: all 0.5s ease-in-out;
  position: relative;
  @media (max-width: 910px) {
    width: 85%;
    padding: 10px;
  }
`;
export const GraphicRotateDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-in-out;
`;
export const HeaderDiv = styled.div`
  padding-left: 28px;
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
export const GraphicTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #000;
  text-align: center;
  @media (max-width: 910px) {
    font-size: 14px;
  }
  @media (max-width: 490px) {
    font-size: 12px;
  }
`;
export const LegendDiv = styled.div`
  padding-left: 28px;
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const LegendColorDiv = styled.div`
  margin: ${({ margin }) => margin && margin};
  width: 20px;
  height: 20px;
  background-color: ${({ color }) => color && color};
  border: ${({ border }) => border && "1px solid #e2e2e2"};
`;
export const GraphicSizeDiv = styled.div`
  padding-left: 28px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ align }) => align && align};
  overflow: auto;

  @media (max-width: 800px) {
    width: 92%;
  }
  @media (max-width: 500px) {
    width: 88%;
  }
`;
export const AxisX = styled.p`
  padding-left: 28px;
  margin-top: 10px;
  width: 100%;
  font-size: 14px;
  color: #666;
  display: flex;
  justify-content: center;
`;
export const HeatMapStyled = styled(HeatMapGrid)``;
